import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import SelectButtonQuizType from '../../components/SelectButtonQuizType';
import SelectPictureQuizType from '../../components/SelectPictureQuizType.jsx';
import './SelectPage.scss';

const quizData = [
	{
		no: 1,
		type: 1,
		title: '두 아이 중 후이를 선택해주세요!',
		picture: '/assets/q2.webp',
		button1: '왼쪽',
		button2: '오른쪽',
		answer: '2',
		explanation: '오른쪽 아이가 루이입니다.',
	},
	{
		no: 2,
		type: 1,
		title: '대나무를 먹는 귀여운 아이, 둘 중 루이는 누구일까요?',
		picture: '/assets/q5.webp',
		button1: '왼쪽',
		button2: '오른쪽',
		answer: '2',
		explanation: '오른쪽 아이가 루이입니다.',
	},
	{
		no: 3,
		type: 1,
		title: '두 아이 중 루이를 선택해주세요!',
		picture: '/assets/q1.webp',
		button1: '왼쪽',
		button2: '오른쪽',
		answer: '2',
		explanation: '오른쪽 아이가 루이입니다.',
	},
	{
		no: 4,
		type: 1,
		title: '귀여운 후이와 루이의 뒷모습! 누가 후이일까요?',
		picture: '/assets/q3.webp',
		button1: '왼쪽',
		button2: '오른쪽',
		answer: '1',
		explanation: '오른쪽 아이가 루이입니다.',
	},
	{
		no: 5,
		type: 1,
		title: '겹쳐 누워 있는 후이와 루이 중 루이는 누구일까요?',
		picture: '/assets/q4.webp',
		button1: '위쪽',
		button2: '아래쪽',
		answer: '1',
		explanation: '오른쪽 아이가 루이입니다.',
	},
	{
		no: 6,
		type: 1,
		title: '쌍둥바오의 이름 뜻 찾아내기',
		picture: '/assets/q8.webp',
		button1: '루이바오 - 슬기로운 보물\n후이바오 - 빛나는 보물',
		button2: '루이바오 - 빛나는 보물\n후이바오 - 슬기로운 보물',
		answer: '1',
		explanation: '오른쪽 아이가 루이입니다.',
	},
	{
		no: 7,
		type: 1,
		title: '자리 경쟁 중인 루이와 후이, 둘 중 루이는 누구일까요?',
		picture: '/assets/q7.png',
		button1: '왼쪽',
		button2: '오른쪽',
		answer: '1',
		explanation: '오른쪽 아이가 루이입니다.',
	},
	{
		no: 8,
		type: 1,
		title: '유채밭에 숨어있는 판다는 누구일까요?',
		picture: '/assets/q17.webp',
		button1: '루이바오',
		button2: '후이바오',
		answer: '2',
		explanation: '오른쪽 아이가 루이입니다.',
	},
	// {
	// 	no: 6,
	// 	type: 1,
	// 	title: '누워서 멍때리는 아이, 후이와 루이 중 누구일까요?',
	// 	picture: '/assets/q6.webp',
	// 	button1: '루이바오',
	// 	button2: '후이바오',
	// 	answer: '1',
	// },
	// {
	// 	no: 9,
	// 	type: 1,
	// 	title: '루이와 후이의 콧잔등 가마는 몇 개 일까요?',
	// 	picture: '/assets/q9.webp',
	// 	button1: '후이는 2개 / 루이는 1개',
	// 	button2: '루이는 2개 / 후이는 1개',
	// 	answer: '2',
	// },
	// {
	// 	no: 10,
	// 	type: 1,
	// 	title: '루이와 후이의 선글라스 모양은?',
	// 	picture: '/assets/q10.webp',
	// 	button1: '후이 - 타원 / 루이 - 하트',
	// 	button2: '후이 - 하트 / 루이 - 타원',
	// 	answer: '2',
	// },
	// {
	// 	no: 11,
	// 	type: 1,
	// 	title: '루이, 후이의 등모양(볼레로)을 맞춰주세요!',
	// 	picture: '/assets/q11.webp',
	// 	button1: '루이 - 넓은 라운드\n후이 - 깊은 브이',
	// 	button2: '후이 - 넓은 라운드\n루이 - 깊은 브이',
	// 	answer: '1',
	// },
	// {
	// 	no: 12,
	// 	type: 1,
	// 	title: '루이 후이의 정수리 모양을 맞춰보세요!',
	// 	picture: '/assets/q12.webp',
	// 	button1: '후이 - 둥글다 / 루이 - 뾰족하다',
	// 	button2: '루이 - 둥글다 / 후이 - 뾰족하다',
	// 	answer: '1',
	// },
	// {
	// 	no: 13,
	// 	type: 1,
	// 	title: '루이 후이 다리를 구분해보세요',
	// 	picture: '/assets/q13.webp',
	// 	button1: '루이 - 길고 날씬하다\n후이 - 뱃살이 있고 다리가 짧다',
	// 	button2: '후이 - 길고 날씬하다\n루이 - 뱃살이 있고 다리가 짧다',
	// 	answer: '1',
	// },
	// {
	// 	no: 14,
	// 	type: 1,
	// 	title: '느긋하게 누워 있는 이 판다는 누구일까요?',
	// 	picture: '/assets/q14.webp',
	// 	button1: '후이바오',
	// 	button2: '루이바오',
	// 	answer: '2',
	// },
	// {
	// 	no: 15,
	// 	type: 1,
	// 	title: '지금 바구니를 타고 있는 판다는 누구일까요?',
	// 	picture: '/assets/q15.webp',
	// 	button1: '후이바오',
	// 	button2: '루이바오',
	// 	answer: '1',
	// },
	// {
	// 	no: 16,
	// 	type: 1,
	// 	title: '상자 안에 들어간 판다는 누구일까요?',
	// 	picture: '/assets/q16.webp',
	// 	button1: '후이바오',
	// 	button2: '루이바오',
	// 	answer: '1',
	// },
	// {
	// 	no: 17,
	// 	type: 1,
	// 	title: '유채밭에 숨어있는 판다는 누구일까요?',
	// 	picture: '/assets/q17.webp',
	// 	button1: '루이바오',
	// 	button2: '후이바오',
	// 	answer: '2',
	// },
];

const SelectPage = () => {
	const [currentQuizNo, setCurrentQuizNo] = useState(1);
	const [score, setScore] = useState(0);
	const currentQuiz = quizData.find(quiz => quiz.no === currentQuizNo);
	const navigate = useNavigate();

	// useEffect(() => {
	// 	document.body.style.overflow = 'hidden';

	// 	return () => {
	// 		document.body.style.overflow = 'auto';
	// 	};
	// }, []);

	// 초기 이미지 미리 로드
	useEffect(() => {
		if (quizData.length > 0) {
			const firstImg = new Image();
			firstImg.src = quizData[0].picture;
		}
	}, []);

	useEffect(() => {
		const nextQuiz = quizData.find(quiz => quiz.no === currentQuizNo + 1);
		if (nextQuiz && nextQuiz.picture) {
			const img = new Image();
			img.src = nextQuiz.picture;
		}
	}, [currentQuizNo]);

	const handleAnswer = selectedAnswer => {
		if (selectedAnswer.toString() === currentQuiz.answer) {
			setScore(prevScore => {
				const updatedScore = prevScore + 1;
				processNextStep();
				return updatedScore;
			});
		} else {
			processNextStep();
		}
	};

	useEffect(() => {
		if (currentQuizNo > quizData.length) {
			navigate('/loading', { state: { score } });
			window.scrollTo(0, 0);
		}
	}, [currentQuizNo, score, navigate]);
	window.scrollTo(0, 0);

	const processNextStep = () => {
		setCurrentQuizNo(prev => prev + 1);
	};

	return (
		<div className="quiz-container">
			<div className="quiz-head">
				<div className="quiz-head-info">
					<div className="quiz-head-info-num">
						<span className="quiz-head-info-num-text">
							Q. {currentQuiz?.no}
						</span>
					</div>
					<div className="quiz-head-info-indicator">
						<span className="quiz-head-info-indicator-text">
							{currentQuizNo} / {quizData.length}
						</span>
					</div>
				</div>
				<div className="quiz-head-title">
					<p className="quiz-head-title-text">{currentQuiz?.title}</p>
				</div>
			</div>
			<div className="quiz-body">
				{currentQuiz?.type === 1 ? (
					<SelectButtonQuizType
						picture={currentQuiz?.picture}
						button1={currentQuiz?.button1}
						button2={currentQuiz?.button2}
						onAnswer={handleAnswer}
					/>
				) : (
					<SelectPictureQuizType
						picture1={currentQuiz?.picture1}
						picture2={currentQuiz?.picture2}
						onAnswer={handleAnswer}
					/>
				)}
			</div>
		</div>
	);
};

export default SelectPage;
